import * as React from 'react';
import { useRef } from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import triangleIcon from '@icons/triangleIcon';
import { renderOptions } from './renderOptions';
import { formatDate } from '@helpers/date';

import * as styles from './style.module.scss';
const {
  accordionItem,
  accordionItem__mainHeading,
  accordionItem__container,
  accordionItem__item,
  accordionItem__summary,
  accordionItem__summary__date,
  accordionItem__summary__issue,
  accordionItem__details,
  accordionItem__content,
} = styles;

const AccordionContent = ({ content: { heading, accordionData } }) => {
  const accordionItems = useRef(null);
  const [open, setOpen] = React.useState(0);

  function handleClick(index) {
    setOpen(open === index ? -1 : index);
  }

  function renderRichText({ raw, references }) {
    const textObject = JSON.parse(raw);
    return documentToReactComponents(textObject, renderOptions(references));
  }

  return (
    <section className={accordionItem}>
      <h2 className={accordionItem__mainHeading}>{heading}</h2>
      <div className={accordionItem__container} ref={accordionItems}>
        {accordionData &&
          accordionData.map(({ title, issue, date, content }, index) => (
            <details
              role="presentation"
              className={accordionItem__item}
              key={`details-index-${index}`}
              open={index === open}
              onClick={(e) => {
                e.preventDefault();
                handleClick(index);
              }}
            >
              <summary className={accordionItem__summary}>
                <div>
                  <p>
                    {issue && (
                      <span className={accordionItem__summary__issue}>
                        {`${issue} - `}
                      </span>
                    )}
                    {title}
                  </p>
                  {triangleIcon}
                </div>
                {date && (
                  <p className={accordionItem__summary__date}>
                    {formatDate(date)}
                  </p>
                )}
              </summary>
              <div className={accordionItem__details}>
                {content && (
                  <div className={accordionItem__content}>
                    {renderRichText(content)}
                  </div>
                )}
              </div>
            </details>
          ))}
      </div>
    </section>
  );
};

export default AccordionContent;
